import './AccessSentMailPopUp.css';

const AccessSentPopUp: React.FC = () => {

return (
    <div className="PopUpDiv">
      <p className="PopUpMessage">Afin de vérifier votre identité, un mail vous a été envoyé.  Merci de cliquer sur le lien contenu dans le mail</p>
    </div>
  );
}

export default AccessSentPopUp;